import { render, staticRenderFns } from "./check-detail.vue?vue&type=template&id=add3f54c&scoped=true"
import script from "./check-detail.vue?vue&type=script&lang=js"
export * from "./check-detail.vue?vue&type=script&lang=js"
import style0 from "./check-detail.vue?vue&type=style&index=0&id=add3f54c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add3f54c",
  null
  
)

export default component.exports